/* eslint-disable no-underscore-dangle */
import PagingFeed from '../lib/PagingFeed';

class PagingOsUpgradePlanFeed extends PagingFeed {
  _getFeed() {
    return this._EntityDef.startOsUpgradePlansFeed(
      this._activeOrgId,
      this._filter,
      this._entityFields,
      this._sort,
      {skip: 0, limit: 100}
    );
  }

  _getDistinctValuesOfField(tenantId, field) {
    return this._EntityDef.startOsUpgradePlanDistinctValuesFeed(tenantId, field);
  }

  _getFeedIdsForSelection(tenantId, selection) {
    return this._EntityDef.loadOsUpgradePlanIdsForSelection(tenantId, selection);
  }

  getOsUpgradePlanEntitiesById(ids) {
    return this.getEntitiesById(ids);
  }

  getOsUpgradePlanEntitiesNameById(ids) {
    return this.getEntitiesNameById(ids);
  }

  getOsUpgradePlanEntityById(id) {
    return this.getEntityById(id);
  }
}

export default PagingOsUpgradePlanFeed;
